import * as yup from 'yup';

import { LoanProductRegValid } from '../util/mappings/loanProductRegValidations';
import errorText from './validationTexts';

export const euroTaxSearchSchema = (regValid: LoanProductRegValid) => {
    return yup.object().shape({
        regNr: yup
            .string()
            .trim()
            .min(regValid.min, errorText.regNoRequired)
            .max(regValid.max, errorText.regNoRequired)
            .typeError(errorText.regNoRequired)
            .matches(regValid.expression, errorText.regNoNotValid)
            .required(errorText.regNoRequired),
    });
};

export default { euroTaxSearchSchema };
